// show selected article offer text
$('#article_offer_text').on('change', function (event) {
    let text = $(event.target).find('option:selected').data('long-text');
    $('#selected-article-offer-text').html(text);
})
